// ScrollToTopButton.js
import React, { useEffect, useState } from 'react';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    setVisible(window.scrollY > 200);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
    //   style={{
    //     position: 'fixed',
    //     right: '0%',
    //     transform: 'translateX(-50%)',
    //     bottom: '20%',
    //     padding: '10px 20px',
    //     backgroundColor: '#007BFF',
    //     color: '#fff',
    //     border: 'none',
    //     borderRadius: '8px',
    //     cursor: 'pointer',
    //     zIndex: 1000,
    //   }}
    className='scrolltotop-sec'
    >
      TOP
    </button>
  );
};

export default ScrollToTopButton;
